import React from 'react';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';

const MainSec2 = () => {
  return (
    <>
      <Container >
        <div className='row justify-content-center mt-5'>
          <div className='col-lg-5 justify-content-center'>
            <Form>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Control type="text" placeholder="NAME" className='contact-input-sec' />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Control type="number" placeholder="PHONE" className='contact-input-sec' />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Control type="email" placeholder="EMAIL" className='contact-input-sec' />
              </Form.Group>
              <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                <Form.Control as="textarea" rows={3} placeholder="COMMENT" className='contact-input-sec' />
              </Form.Group>
              <div className='contact-sec4-dt-btn-div'>
                <button className='contact-sec4-dt-btn'>Send</button>
              </div>
            </Form>
            <div className='contact-sec3-text-div mt-5 mb-5'>
              <h4 className='contact-sec3-text-h4'>Subscribe to our emails</h4>
              <span className='contact-sec3-text-span'>Be the first to know about new collections and exclusive offers.</span>
              <button className='contact-sec3-text-btn'>Email</button>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default MainSec2